import { useEffect } from "react";

function usePageTitle(title: string | undefined) {
  useEffect(() => {
    document.title = title || "";
  }, [title]);
}
export { usePageTitle };
